import { createContext, SetStateAction, Dispatch } from "react";

import { LOADING_SAVED_QUOTATIONS_STATES, QuotationInfo } from "../../interfaces";
import { LOADING_RENEWAL_QUOTATION_STATES } from "../../interfaces/loading-renewal-quotation-states-enum";
interface QuotationInfoContextProps {
    allArticleSelected:             any;
    setAllArticleSelected:          Dispatch<SetStateAction<any>>;

    canShowConfirmIssue:            boolean;
    setCanShowConfirmIssue:         Dispatch<SetStateAction<boolean>>;

    canShowConfirmRenewal:            boolean;
    setCanShowConfirmRenewal:         Dispatch<SetStateAction<boolean>>;

    /** Current step of Quotation Proccess */
    currentStep:                    number;
    setCurrentStep:                 Dispatch<SetStateAction<number>>;

    /** Info of type of quotation selected */
    quotationInfo?:                 QuotationInfo;
    setQuotationInfo:               Dispatch<SetStateAction<QuotationInfo | undefined>>;

    quoatationInfoRequest?:         any;
    setQuoatationInfoRequest:       Dispatch<SetStateAction<any>>;


    /** Flag to indicate if is loading a renewal quotation */
    loadingSavedQuotation:          boolean;
    setLoadingSavedQuotation:       Dispatch<SetStateAction<boolean>>;

    /** Flag to indicate if is loading a saved quotation */
    savedQuotation:                 any;
    setSavedQuotation:              Dispatch<SetStateAction<any>>;
    
    loadSaveQuotationState:         LOADING_SAVED_QUOTATIONS_STATES | undefined;
    setLoadSaveQuotationState:      Dispatch<SetStateAction<LOADING_SAVED_QUOTATIONS_STATES | undefined>>;

    loadingRenewalQuotation:          boolean;
    setLoadingRenewalQuotation:       Dispatch<SetStateAction<boolean>>;

    quotationToRenewal:             any;
    setQuotationToRenewal:          Dispatch<SetStateAction<any>>;

    renewalQuotationState:         LOADING_RENEWAL_QUOTATION_STATES | undefined;
    setRenewalQuotationState:      Dispatch<SetStateAction<LOADING_RENEWAL_QUOTATION_STATES | undefined>>;
}

export const QuotationInfoContext = createContext({} as QuotationInfoContextProps);